<template>
  <v-dialog v-model="visible" width="75rem" persistent scrollable>
    <v-card v-if="is_loading">
      <v-skeleton-loader type="card, list-item@8" />
    </v-card>
    <template v-else>
      <v-card>
        <v-toolbar color="primary white--text" flat>
          <sabira_icon
            icon="marketing"
            class="mr-3"
            :strokewidth="3"
            fill="white"
          />
          <v-toolbar-title class="ml-1" v-if="mc.id > 0">
            {{ this.mc.campaign_name }}
          </v-toolbar-title>
          <v-toolbar-title class="ml-1" v-else>
            {{ title2 }}
          </v-toolbar-title>
          <v-spacer></v-spacer>
          <div class="text-h5 mr-4">
            {{ $n(parseFloat(grand_total).toFixed(2)) }} KM
          </div>
          <v-toolbar-items v-if="mc.id > 0">
            <v-tooltip left color="#e9c46a" open-on-hover open-delay="150">
              <template v-slot:activator="{ on, attrs }">
                <v-btn icon @click="print(false)" v-bind="attrs" v-on="on">
                  <sabira_icon icon="file-pdf" fill="white"></sabira_icon>
                </v-btn>
              </template>
              <span>Marketing kampanja pdf</span>
            </v-tooltip>
            <v-tooltip left color="#e9c46a" open-on-hover open-delay="150">
              <template v-slot:activator="{ on, attrs }">
                <v-btn icon @click="show_email = true" v-bind="attrs" v-on="on">
                  <sabira_icon icon="email_invoice" fill="white"></sabira_icon>
                </v-btn>
              </template>
              <span>Pošalji marketing kampanju</span>
            </v-tooltip>
            <v-tooltip left color="#e9c46a" open-on-hover open-delay="150">
              <template v-slot:activator="{ on, attrs }">
                <v-btn icon @click="copy_to_invoice()" v-bind="attrs" v-on="on">
                  <sabira_icon icon="invoice" fill="white"></sabira_icon>
                </v-btn>
              </template>
              <span>Kopiraj marketing kampanju</span>
            </v-tooltip>
            <v-spacer></v-spacer>
            <v-tooltip left color="#e9c46a" open-on-hover open-delay="150">
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  icon
                  @click="show_delete_options = true"
                  v-bind="attrs"
                  v-on="on"
                >
                  <sabira_icon icon="trash" fill="white"></sabira_icon>
                </v-btn>
              </template>
              <span>Obriši marketing kampanju</span>
            </v-tooltip>
          </v-toolbar-items>
          <template v-slot:extension>
            <v-tabs
              v-model="active_tab"
              hide-slider
              background-color="background darken"
            >
              <v-tab>Info</v-tab>
              <v-tab>Ciljevi</v-tab>
              <v-tab>Troškovi</v-tab>
              <v-tab>Artikli</v-tab>
              <v-tab>PI (ROI)</v-tab>
            </v-tabs>
          </template> </v-toolbar
        ><v-sheet height="3rem" class="pl-7 pt-3" color="quinary">
          <sabira_progress_bar
            class="tertiry--text"
            :status="{
              min: 0,
              max: mc.planned_budget,
              current: parseFloat(total_expense).toFixed(2),
            }"
          ></sabira_progress_bar>
        </v-sheet>
        <v-card-text class="pa-4">
          <v-tabs-items v-model="active_tab">
            <v-tab-item>
              <div
                style="display:grid;grid-template-columns:1fr 1fr 1fr;grid-row-gap: 1rem;margin-bottom:-1rem;"
              >
                <v-text-field
                  v-model="mc.campaign_name"
                  label="Naziv kampanje"
                  outlined
                  class="mr-4 pt-1"
                  maxlength="100"
                  counter
                ></v-text-field>
                <v-dialog
                  ref="dialog_campaign_start"
                  v-model="modal_campaign_start"
                  :return-value.sync="mc.campaign_start"
                  persistent
                  width="290px"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      :value="campaign_start_formatted"
                      label="Kampanja počinje na datum"
                      prepend-inner-icon="mdi-calendar"
                      readonly
                      outlined
                      hide-details
                      v-bind="attrs"
                      v-on="on"
                      :width="80"
                      class="mr-4 pt-1"
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    v-model="mc.campaign_start"
                    @change="save_campaign_start"
                    locale="bs-bs"
                    :first-day-of-week="1"
                    :show-week="true"
                  >
                  </v-date-picker>
                </v-dialog>
                <v-dialog
                  ref="dialog_campaign_end"
                  v-model="modal_campaign_end"
                  :return-value.sync="mc.campaign_end"
                  persistent
                  width="290px"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      v-model="campaign_end_formatted"
                      label="Kampanja završava na datum"
                      prepend-inner-icon="mdi-calendar"
                      readonly
                      outlined
                      hide-details
                      v-bind="attrs"
                      v-on="on"
                      :width="80"
                      class="pt-1"
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    v-model="mc.campaign_end"
                    @change="save_campaign_end"
                    locale="bs-bs"
                    :first-day-of-week="1"
                    :show-week="true"
                  >
                  </v-date-picker>
                </v-dialog>
              </div>
              <div
                style="margin-top:1rem;margin-bottom:-0.7rem;display:grid;grid-template-columns:1fr 1fr;grid-row-gap: 1rem;"
              >
                <v-textarea
                  outlined
                  style="padding-bottom:-2rem;"
                  class="mr-4"
                  label="Opis marketing kampanje"
                  rows="5"
                  v-model="mc.campaign_description"
                  clearable
                  maxlength="1000"
                  counter
                  placeholder="Generalni opis i svrha marketing kampanje"
                >
                </v-textarea>
                <div>
                  <div
                    style="display:grid;grid-template-columns:1fr 1fr;margin-bottom:1.6rem;"
                  >
                    <v-select
                      class="mt-0 mr-2"
                      :items="statuses"
                      label="Status kampanje"
                      v-model="mc.status"
                      hide-details
                      outlined
                      clearable
                    ></v-select>
                    <v-text-field
                      class="ml-2"
                      hide-details
                      v-model.number="mc.status_percent"
                      outlined
                      label="Status %"
                      type="number"
                      @input="validate2()"
                    ></v-text-field>
                  </div>
                  <div
                    style="display:grid;grid-template-columns:1fr 1fr;column-gap:1rem;"
                  >
                    <webpage_lookup_work_order_worker
                      update="wp_worker_changed"
                      :selected_id="mc.employee_id"
                    ></webpage_lookup_work_order_worker>
                    <webpage_lookup_departments
                      update="wp_department_changed"
                      :selected_id="mc.department_id"
                    ></webpage_lookup_departments>
                  </div>
                </div>
              </div>
              <div
                style="display:grid;grid-template-columns:1fr 1fr 1fr;grid-row-gap: 1rem;"
              >
                <v-text-field
                  class="mr-4 mt-3"
                  outlined
                  type="number"
                  label="Planirani budžet - ručni unos"
                  v-model="mc.planned_budget"
                  >0</v-text-field
                >
                <div>
                  <v-chip label large outlined color="primary" class="mt-3">
                    {{
                      "Ukupni trošak " +
                        $n(parseFloat(total_expense).toFixed(2))
                    }}
                  </v-chip>
                </div>
                <v-text-field
                  class="mt-3"
                  outlined
                  readonly
                  label="Povrat investicije - automatski obračun"
                  v-model="mc.roi"
                ></v-text-field>
              </div>
              <div
                style="display:grid;grid-template-columns:1fr 1fr 1fr;grid-row-gap: 1rem;"
              >
                <v-chip outlined label large color="primary" class="mr-4">
                  {{ "Trošak dobavljača " + suppliers_expense_formatted }}
                </v-chip>
                <div>
                  <v-chip outlined label large color="primary" class="mr-4">{{
                    "Artikli " +
                      this.$n(parseFloat(this.grand_total).toFixed(2))
                  }}</v-chip>
                </div>
                <v-text-field
                  outlined
                  type="number"
                  label="Ostali troškovi - ručni unos"
                  v-model.number="mc.other_expenses"
                ></v-text-field>
              </div>
            </v-tab-item>
            <v-tab-item>
              <div v-if="mc.id == 0">
                <div
                  class="height-90vh"
                  style="display:grid;grid-template-columns: 1fr 1fr
                max-content;grid-column-gap:1rem;align-items:center;"
                  v-for="(description, index) in item.description.desc_item"
                  :key="index"
                >
                  <v-text-field
                    v-model="item.description.desc_item[index]"
                    :label="'Cilj ' + (index + 1)"
                    outlined
                    maxlength="255"
                    counter
                    class="ml-4 pt-1 mb-0 pb-0"
                  ></v-text-field>
                  <v-btn
                    v-if="index > 0"
                    @click="removeDescription(index)"
                    icon
                    class="mb-5 mr-4"
                  >
                    <sabira_icon
                      icon="trash"
                      fill="grey"
                      :width="38"
                      :height="38"
                      :strokewidth="3"
                    ></sabira_icon>
                  </v-btn>
                  <v-btn
                    icon
                    v-else
                    color="primary"
                    dark
                    @click="addDescription()"
                    class="mb-5 mr-4"
                    ><sabira_icon
                      icon="plus"
                      fill="grey"
                      :width="38"
                      :height="38"
                      :strokewidth="3"
                    ></sabira_icon
                  ></v-btn>
                </div>
              </div>
              <div v-else>
                <div v-for="(description, index) in descriptions" :key="index">
                  <v-list>
                    <v-list-item>
                      <v-list-item-content>
                        <v-text-field
                          dense
                          outlined
                          v-model="descriptions[index]"
                          label="Cilj"
                        >
                        </v-text-field>
                        <v-text-field
                          dense
                          outlined
                          type="number"
                          hide-details
                          v-model.number="goals_scores[index]"
                          label="Realizacija %"
                          @input="validate3(index)"
                        ></v-text-field>
                      </v-list-item-content>
                    </v-list-item>
                  </v-list>
                </div>
              </div>
            </v-tab-item>
            <v-tab-item>
              <v-text-field
                clearable
                hide-details
                prepend-inner-icon="mdi-magnify"
                label="Pretraga marketing troškova u kampanji"
                placeholder="Unesite naziv pojma za pretragu"
                v-model="search_text"
                outlined
                class="mt-1"
              ></v-text-field>
              <v-card flat v-if="is_loading">
                <v-skeleton-loader type="table, list-item@6" />
              </v-card>
              <template v-else>
                <v-data-table
                  style="background: transparent;"
                  no-data-text="Podaci ne postoje za odabranu kategoriju"
                  :search="search_text"
                  :loading="is_loading"
                  :items="items"
                  :headers="headers1"
                  :options="{ itemsPerPage: 50 }"
                  :footer-props="{
                    'items-per-page-options': [10, 25, 50, -1],
                    'items-per-page-text': 'Broj zapisa po stranici',
                    'items-per-page-all-text': 'Svi',
                    'page-text': '{0}-{1} od {2}',
                  }"
                >
                  <template v-slot:[`item.supplier_naziv`]="{ item }">
                    <div class="body-2" style="font-weight: 500;">
                      {{ item.supplier_naziv }}
                    </div>
                  </template>
                  <template v-slot:[`item.uplaceno_datum`]="{ item }">
                    {{ $moment(new Date(item.uplaceno_datum)).format("L") }}
                  </template>
                  <template v-slot:[`item.uplaceno_km`]="{ item }">
                    {{ $n(item.uplaceno_km) }}
                  </template>
                  <template v-slot:[`item.referenca`]="{ item }">
                    <div
                      style="display:grid;grid-template-columns: max-content 1fr"
                    >
                      <div class="mt-2 mb-2">
                        <div>{{ item.referenca }}</div>
                      </div>
                    </div>
                  </template>
                </v-data-table>
              </template>
            </v-tab-item>
            <v-tab-item>
              <div
                style="margin-top:0.7rem;align-items:center;display:grid;grid-template-columns: 0.98fr 1fr;grid-column-gap:1rem;"
              >
                <webpage_lookup_artikli
                  update="wp_artikal_changed"
                ></webpage_lookup_artikli>
                <v-btn
                  class="ml-0"
                  icon
                  color="primary"
                  dark
                  @click="dodaj_artikal()"
                  ><sabira_icon
                    icon="plus"
                    fill="grey"
                    :width="38"
                    :height="38"
                    :strokewidth="3"
                    class="ml-3"
                  ></sabira_icon
                ></v-btn>
              </div>
              <v-data-table
                class="mt-2"
                :items="mc.artikli"
                :headers="headers"
                disable-pagination
                hide-default-footer
                no-data-text="Podaci ne postoje za odabranu kategoriju"
              >
                <template v-slot:[`item.kom`]="{ item }">
                  <v-text-field
                    v-model.number="item.kom"
                    outlined
                    hide-details
                    dense
                    type="number"
                  ></v-text-field>
                </template>
                <template v-slot:[`item.ukupno`]="{ item }">
                  {{ $n(parseFloat(item.ukupno).toFixed(2)) }}
                </template>
                <template v-slot:[`item.jm_id`]="{ item }">
                  <webpage_lookup_jedinice_mjere
                    :selected_id="item.jm_id"
                    :reference_id="item.id"
                    update="wp_event_jm_updated"
                  ></webpage_lookup_jedinice_mjere>
                </template>
                <template v-slot:[`item.rabat`]="{ item }">
                  <v-text-field
                    v-model.number="item.rabat"
                    outlined
                    hide-details
                    dense
                    type="number"
                  ></v-text-field>
                </template>
                <template v-slot:[`item.cijena`]="{ item }">
                  {{ $n(parseFloat(item.cijena).toFixed(2)) }}
                </template>
                <template v-slot:[`body.append`]>
                  <tr>
                    <td :colspan="7" style="text-align:right">
                      Ukupno bez PDV-a:
                    </td>
                    <td style="text-align:left">
                      {{ $n(parseFloat(mc_total).toFixed(2)) }}
                    </td>
                  </tr>
                  <tr>
                    <td :colspan="7" style="text-align:right">
                      PDV:
                    </td>
                    <td style="text-align:left">
                      {{ $n(parseFloat(tax_total).toFixed(2)) }}
                    </td>
                  </tr>
                  <tr>
                    <td :colspan="7" style="text-align:right">
                      Vrijednost poslova:
                    </td>
                    <td style="text-align:left">
                      {{ $n(parseFloat(grand_total).toFixed(2)) }}
                    </td>
                  </tr>
                </template>
                <template v-slot:[`item.actions`]="{ item }">
                  <v-btn icon @click="remove_artikal(item)"
                    ><sabira_icon icon="trash" fill="grey"></sabira_icon
                  ></v-btn>
                </template> </v-data-table
            ></v-tab-item>
            <v-tab-item> </v-tab-item>
          </v-tabs-items>
        </v-card-text>
        <v-card-actions class="background">
          <v-btn text @click="close_dialog">Odustani</v-btn>
          <v-spacer></v-spacer>
          <v-btn
            :loading="is_btn_loading"
            text
            depressed
            @click="save_campaign()"
            >Snimi</v-btn
          >
        </v-card-actions>
        <vue-qr
          :text="'mc.campaign_name'"
          :margin="0"
          :callback="raw_qrcode"
          :whiteMargin="false"
          :width="60"
          style="display:none;"
          backgroundColor="transparent"
        ></vue-qr>
      </v-card>
    </template>
    <v-dialog width="30rem" persistent scrollable v-model="show_delete_options">
      <v-card>
        <v-card-title class="pb-0 mb-0">Brisanje radnog naloga</v-card-title>
        <v-card-text class="pt-0 mt-0">
          <v-list color="transparent">
            <v-list-item>
              <v-list-item-content>
                {{ "Želite obrisati kampanju?" }}
              </v-list-item-content>
            </v-list-item>
          </v-list>
        </v-card-text>
        <v-card-actions class="background">
          <v-btn text @click="show_delete_options = false">Odustani</v-btn>
          <v-spacer></v-spacer>
          <v-btn text @click="delete_mc()">Obriši</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <sabira_email
      :sender="email.sender"
      :message="email.message"
      :subject="email.subject"
      :attachments="email.attachments"
      :recipients="email.recipients"
      :visible="show_email"
      close="close_email_dialog"
    ></sabira_email>
  </v-dialog>
</template>
<script>
import VueQr from "vue-qr";
export default {
  components: {
    sabira_icon: () => import("@/components/sabira_icon"),
    webpage_lookup_work_order_worker: () =>
      import("@/components/lookups/work_order_worker"),
    webpage_lookup_artikli: () => import("@/components/lookups/artikli"),
    webpage_lookup_jedinice_mjere: () =>
      import("@/components/lookups/jedinice_mjere"),
    sabira_email: () => import("@/components/email"),
    webpage_lookup_departments: () =>
      import("@/components/lookups/departments"),
    sabira_progress_bar: () =>
      import("@/components/campaign_budget_progress_bar"),
    VueQr,
  },
  props: {
    id: {
      type: Number,
      default: 0,
    },

    close: {
      type: String,
      default: null,
    },
  },
  computed: {
    total_expense_calculated() {
      return parseFloat(
        this.mc.other_expenses + this.suppliers_expense + this.grand_total
      ).toFixed(2);
    },
    suppliers_expense_formatted() {
      return this.suppliers_expense
        ? this.$n(parseFloat(this.suppliers_expense).toFixed(2))
        : 0;
    },
    campaign_start_formatted() {
      return this.mc.campaign_start
        ? this.$moment(new Date(this.mc.campaign_start)).format("Do MMMM YYYY")
        : null;
    },
    campaign_end_formatted() {
      return this.mc.campaign_end
        ? this.$moment(new Date(this.mc.campaign_end)).format("Do MMMM YYYY")
        : null;
    },
    mc_total() {
      return typeof this.mc.artikli !== "undefined" &&
        this.mc.artikli !== null &&
        this.mc.artikli.length
        ? this.mc.artikli
            .map((x) => x.ukupno)
            .reduce((a, b) => {
              return a + b;
            })
        : 0;
    },
    tax_total() {
      return typeof this.mc.artikli !== "undefined" &&
        this.mc.artikli !== null &&
        this.mc.artikli.length
        ? this.mc.artikli
            .map((x) => x.pdv_total)
            .reduce((a, b) => {
              return a + b;
            })
        : 0;
    },
    grand_total() {
      return typeof this.mc.artikli !== "undefined" &&
        this.mc.artikli !== null &&
        this.mc.artikli.length
        ? this.mc.artikli
            .map((x) => x.total)
            .reduce((a, b) => {
              return a + b;
            })
        : 0;
    },
  },
  data: () => ({
    descriptions: [],
    goals_scores: [],
    search_text: null,
    active_tab: 0,
    title2: "Kreiranje nove marketing kampanje",
    qrcode_image: null,
    show_print_options: false,
    show_delete_options: false,
    show_email: false,
    is_btn_loading: false,
    modal_campaign_start: false,
    modal_campaign_end: false,
    is_loading: true,
    visible: false,
    items: [],
    statuses: [
      { text: "Planiranje", value: "Planiranje" },
      { text: "Nabavka materijala", value: "Nabavka materijala" },
      { text: "U izradi", value: "U izradi" },
      { text: "Rad sa dobavljačima", value: "Rad sa dobavljačima" },

      { text: "Završena", value: "Završena" },
      { text: "Otkazana", value: "Otkazana" },
    ],
    selected_status: null,
    mc: {
      artikli: [],
      id: 0,
      campaign_name: null,
      campaign_description: null,
      campaign_start: null,
      campaign_end: null,
      status: null,
      status_percent: 0,
      employee_id: null,
      department_id: null,
      planned_budget: 0,
      other_expenses: 0,
      account_id: null,
      year: null,
      mc_goals_id: null,
    },
    item: {
      id: 0,
      description: {
        desc_item: [null],
        desc_score: [0],
      },
    },
    email: {
      recipients: [
        {
          name: null,
          email: null,
        },
      ],
      sender: {
        name: null,
        email: null,
      },
      subject: null,
      message: null,
      attachments: [],
    },
    headers: [
      {
        text: "Šifra",
        value: "sifra",
        align: "left",
        width: "5rem",
      },
      {
        text: "Naziv",
        value: "naziv",
        align: "left",
        width: "10rem",
      },
      {
        text: "Količina",
        value: "kom",
        align: "left",
        width: "7rem",
      },
      {
        text: "JM",
        value: "jm_id",
        width: "3rem",
        align: "left",
      },
      {
        text: "Cijena",
        value: "cijena",
        width: "7rem",
        align: "left",
      },
      {
        text: "Rabat %",
        value: "rabat",
        width: "6rem",
        align: "left",
      },
      {
        text: "Ukupno bez PDV-a",
        value: "ukupno",
        align: "left",
        width: "8rem",
      },
      {
        text: null,
        value: "actions",
        width: "30px",
      },
    ],
    headers1: [
      {
        text: "ID",
        value: "id",
        sortable: true,
        align: "left d-none",
      },
      {
        text: "Opis troška",
        value: "trosak_opis",
        sortable: true,
        align: "left",
      },
      {
        text: "Kampanja",
        value: "campaign_name",
        sortable: true,
        align: "left",
      },
      {
        text: "Dobavljač",
        value: "supplier_naziv",
        sortable: true,
        align: "left",
      },
      {
        text: "Datum isplate",
        value: "uplaceno_datum",
        sortable: true,
        align: "left",
        width: 160,
      },
      {
        text: "Isplaćeno",
        value: "uplaceno_km",
        sortable: true,
        align: "right",
      },
    ],
  }),
  watch: {
    visible: {
      handler() {
        if (this.id > 0) {
          this.get_item();
          this.get_suppliers_expense();
        } else {
          this.mc = {
            artikli: [],
            id: 0,
            campaign_name: null,
            campaign_description: null,
            campaign_start: null,
            campaign_end: null,
            status: null,
            status_percent: 0,
            employee_id: null,
            department_id: null,
            planned_budget: 0,
            other_expenses: 0,
            account_id: null,
            year: null,
            mc_goals_id: null,
          };
          this.item = {
            id: 0,
            description: {
              desc_item: [null],
              desc_score: [0],
            },
          };
          this.suppliers_expense = 0;
          this.is_loading = false;
        }
      },
      immediate: false,
    },
    total_expense_calculated: {
      handler() {
        this.total_expense = this.total_expense_calculated;
      },
      immediate: false,
    },
    show_email: {
      handler() {
        if (this.show_email) {
          this.email.attachments = [];
          this.print(true);
        }
      },
    },
    "mc.artikli": {
      handler() {
        this.mc.artikli.forEach((e_artikal) => {
          e_artikal.ukupno =
            e_artikal.kom *
            (e_artikal.cijena - (e_artikal.cijena * e_artikal.rabat) / 100);
          e_artikal.pdv_total =
            e_artikal.pdv_postotak > 0
              ? (e_artikal.pdv_postotak / 100) * e_artikal.ukupno
              : 0;
          e_artikal.total = e_artikal.ukupno + e_artikal.pdv_total;
        });
      },
      deep: true,
    },
  },
  methods: {
    addDescription() {
      this.item.description.desc_item.push("");
      this.item.description.desc_score.push(0);
    },
    removeDescription(index) {
      this.item.description.desc_item.splice(index, 1);
      this.item.description.desc_score.splice(index, 1);
    },
    validate() {
      return new Promise((resolve, reject) => {
        var has_errors = false;
        if (
          this.mc.campaign_name == null ||
          this.mc.campaign_name.length == 0
        ) {
          has_errors = true;
          reject("Naziv marketing kampanje polje je obavezno");
        }
        for (let i = 0; i < this.mc.artikli.length; i++) {
          const item = this.mc.artikli[i];
          if (
            item.cijena == null ||
            item.cijena === 0 ||
            item.cijena.length === 0
          ) {
            reject(`Cijena artikla polje je obavezno`);
          }
          if (
            item.rabat == null ||
            item.rabat.length === 0 ||
            item.rabat < 0 ||
            item.rabat > 100
          ) {
            reject(`Rabat artikla polje nije ispravno ispunjeno`);
          }
          if (
            item.kom == null ||
            item.kom === 0 ||
            item.kom.length === 0 ||
            item.kom < 0 ||
            item.kom > 2147483647
          ) {
            reject(`Količina artikla polje nije ispravno ispunjeno`);
          }
        }
        if (!has_errors) {
          resolve();
        }
      });
    },
    validate2() {
      return new Promise((resolve, reject) => {
        var has_errors = false;
        if (this.mc.status_percent != null && this.mc.status_percent > 100) {
          this.mc.status_percent = 0;
          has_errors = true;
          this.$webpageEventBus.$emit("show_status", {
            type: "error",
            message: "Max % je 100",
            timeout: 2000,
          });
          reject;
        }
        if (!has_errors) {
          resolve(true);
        }
      });
    },
    validate3(index) {
      return new Promise((resolve, reject) => {
        var has_errors = false;
        if (
          this.goals_scores[index] != null &&
          this.goals_scores[index] > 100
        ) {
          this.goals_scores[index] = null;
          has_errors = true;
          reject("Max vrijednost je 100%.");
        }
        if (!has_errors) {
          resolve(true);
        }
      });
    },
    remove_artikal(item) {
      this.mc.artikli.splice(this.mc.artikli.indexOf(item), 1);
    },
    dodaj_artikal() {
      if (
        this.selected_artikal !== null &&
        typeof this.selected_artikal !== "undefined"
      ) {
        if (
          typeof this.mc.artikli.find(
            (x) => x.id == this.selected_artikal.id
          ) !== "undefined"
        ) {
          var e_artikal = this.mc.artikli.find(
            (x) => x.id == this.selected_artikal.id
          );
          e_artikal.kom += 1;
        } else {
          this.mc.artikli.push({
            id: this.selected_artikal.id,
            sifra: this.selected_artikal.sifra,
            naziv: this.selected_artikal.naziv,
            cijena: this.selected_artikal.vpc,
            kom: 0,
            rabat: 0,
            ukupno: this.selected_artikal.vpc_pdv,
            pdv_postotak: this.selected_artikal.pdv_postotak,
            pdv_total: this.selected_artikal.pdv,
            // (this.selected_artikal.pdv_postotak / 100) *
            // this.selected_artikal.vpc,
            jm_id: 1,
            total: this.selected_artikal.vpc_pdv,
            // this.selected_artikal.vpc +
            // (this.selected_artikal.vpc * this.selected_artikal.pdv_postotak) /
            //   100,
          });
        }
      } else {
        this.$webpageEventBus.$emit("show_status", {
          type: "error",
          message: "Odaberite artikal",
          timeout: 2000,
        });
      }
    },
    get_item() {
      this.$http({
        method: "POST",
        url: "/marketing_campaigns/get_campaign",
        data: {
          account_id: this.$store.getters.user.account_id,
          id: this.id,
        },
      })
        .then((resp) => {
          this.mc = resp.data.result;
          this.is_loading = false;
          if (this.mc.campaign_start != null) {
            this.mc.campaign_start = this.$moment(
              new Date(this.mc.campaign_start)
            )
              .local()
              .format("YYYY-MM-DD HH:SS");
          } else {
            this.mc.campaign_start = null;
          }
          if (this.mc.campaign_end != null) {
            this.mc.campaign_end = this.$moment(new Date(this.mc.campaign_end))
              .local()
              .format("YYYY-MM-DD HH:SS");
          } else {
            this.mc.campaign_end = null;
          }
          this.email.subject = this.mc.campaign_name;
          this.email.sender = {
            name: this.$store.getters.user.name,
            email: this.$store.getters.user.email,
          };
          this.email.message =
            "Poštovana/ni, u prilogu se nalaze podaci za marketing campanju" +
            this.mc.campaign_name +
            ".pdf.";
        })
        .then(() => {
          this.$http({
            method: "POST",
            url: "/mc/get_goals",
            data: {
              account_id: this.$store.getters.user.account_id,
              id: this.mc.mc_goals_id,
            },
          }).then((resp) => {
            this.descriptions = JSON.parse(resp.data[0].description);
            console.log(this.descriptions);
            this.goals_scores = JSON.parse(resp.data[0].goals_score);
            console.log(this.goals_scores);
            this.item.id = resp.data[0].id;
          });
        });
    },
    get_suppliers_expense() {
      this.$http({
        method: "POST",
        url: "/get_suppliers_expense",
        data: {
          account_id: this.$store.getters.user.account_id,
          id: this.id,
        },
      }).then((resp) => {
        this.items = resp.data[0];
        this.suppliers_expense = resp.data[1][0].suppliers_expense;
        this.is_loading = false;
      });
    },
    close_dialog() {
      this.$webpageEventBus.$emit(
        this.close !== null ? this.close : "close_campaign"
      );
    },
    save_campaign_start() {
      this.$refs.dialog_campaign_start.save(this.mc.campaign_start);
    },
    save_campaign_end() {
      this.$refs.dialog_campaign_end.save(this.mc.campaign_end);
    },
    save_campaign() {
      this.validate()
        .then(() => {
          this.is_btn_loading = true;
          this.item.account_id = this.$store.getters.user.account_id;
          if (this.item.id > 0) {
            this.item.description = {
              desc_item: this.descriptions,
              desc_score: this.goals_scores,
            };
          }
          this.$http({
            method: "POST",
            url: "/mc_goals/update",
            data: this.item,
          })
            .then((resp) => {
              if (resp.status === 200) {
                if (this.item.id === 0) {
                  this.$http({
                    method: "POST",
                    url: "mc_goals/last_id",
                    data: {
                      account_id: this.$store.getters.user.account_id,
                    },
                  })
                    .then((resp) => {
                      this.mc.mc_goals_id = resp.data[0]?.id || 0;
                      this.updateCampaign();
                    })
                    .catch((error) => {
                      this.is_btn_loading = false;
                      this.$webpageEventBus.$emit("show_status", {
                        type: "error",
                        message:
                          "Failed to get the last goal ID: " +
                          (error.response?.data?.message || error.message),
                        timeout: 4000,
                      });
                    });
                } else {
                  this.mc.mc_goals_id = this.item.id; // Use existing goal ID
                  this.updateCampaign();
                }
              } else {
                this.is_btn_loading = false;
                this.$webpageEventBus.$emit("show_status", {
                  type: "error",
                  message:
                    "Failed to update the goal: " +
                    (resp.data.message || "Unknown error"),
                  timeout: 4000,
                });
              }
            })
            .catch((error) => {
              this.is_btn_loading = false;
              this.$webpageEventBus.$emit("show_status", {
                type: "error",
                message:
                  "Failed to update the goal: " +
                  (error.response?.data?.message || error.message),
                timeout: 4000,
              });
            });
        })
        .catch((error) => {
          this.is_btn_loading = false;
          this.$webpageEventBus.$emit("show_status", {
            type: "error",
            message: "Validation failed: " + error,
            timeout: 4000,
          });
        });
    },
    updateCampaign() {
      if (this.mc.campaign_start != null) {
        this.mc.campaign_start = this.$moment(this.mc.campaign_start)
          .local()
          .format("YYYY-MM-DD HH:mm");
        this.mc.year = this.mc.campaign_start.substr(0, 4);
      } else {
        this.mc.campaign_start = null;
        this.mc.year = new Date().getFullYear();
      }
      if (this.mc.campaign_end != null) {
        this.mc.campaign_end = this.$moment(this.mc.campaign_end)
          .local()
          .format("YYYY-MM-DD HH:mm");
      } else {
        this.mc.campaign_end = null;
      }
      this.mc.account_id = this.$store.getters.user.account_id;
      this.$http({
        method: "POST",
        url: "/campaign/update",
        data: this.mc,
        headers: {
          "Content-Type": "application/json;charset=utf-8",
        },
      })
        .then((resp) => {
          if (resp.status === 200) {
            this.$webpageEventBus.$emit("show_status", {
              type: "success",
              message: "Marketing kampanja je ažurirana",
              timeout: 2000,
            });
            this.is_btn_loading = false;
            this.$webpageEventBus.$emit("evt_close_campaign");
            this.close_dialog();
            this.$webpageEventBus.$emit("reload_data");
          } else {
            this.is_btn_loading = false;
            this.$webpageEventBus.$emit("show_status", {
              type: "error",
              message: resp.data.message || "Failed to update the campaign",
              timeout: 4000,
            });
          }
        })
        .catch((error) => {
          this.is_btn_loading = false;
          this.$webpageEventBus.$emit("show_status", {
            type: "error",
            message:
              "Failed to update the campaign: " +
              (error.response?.data?.message || error.message),
            timeout: 4000,
          });
        });
    },
    delete_wo() {
      this.$http({
        method: "POST",
        url: "/work_order/delete",
        data: {
          account_id: this.$store.getters.user.account_id,
          id: this.id,
        },
      }).then((resp) => {
        if (resp.status == 200) {
          this.$webpageEventBus.$emit("show_status", {
            type: "success",
            message: "Radni nalog je obrisan",
            timeout: 2000,
          });
          this.close_dialog();
          this.$webpageEventBus.$emit("reload_data");
        } else {
          this.$webpageEventBus.$emit("show_status", {
            type: "error",
            message: resp.data.message,
            timeout: 4000,
          });
        }
      });
    },
    raw_qrcode(dataUrl) {
      this.qrcode_image = dataUrl;
    },
    print(for_email) {
      this.$helpers.generate_mc_pdf(this.mc).then((r) => {
        var mc_pdf = r;
        if (for_email) {
          this.email.attachments.push({
            filename: this.mc.campaign_name + ".pdf",
            content: mc_pdf.content,
            encoding: "binary",
          });
        } else {
          mc_pdf.raw_doc.save(this.mc.campaign_name + ".pdf");
          //invoice_pdf.raw_doc.output("dataurlnewwindow");
        }
      });
    },
    setup_event_listeners() {
      this.$webpageEventBus.$on("wp_worker_changed", (selected_item) => {
        if (selected_item !== null) {
          this.mc.employee_id = selected_item.id;
          this.mc.employee_name = selected_item.name;
          this.mc.employee_position = selected_item.positions_name;
        } else {
          this.mc.employee_id = null;
          this.mc.employee_name = null;
          this.mc.employee_position = null;
        }
      });
      this.$webpageEventBus.$on("wp_department_changed", (selected_item) => {
        if (selected_item !== null) {
          this.mc.department_id = selected_item.id;
        } else {
          this.mc.department_id = null;
        }
      });
      this.$webpageEventBus.$on("wp_artikal_changed", (artikal) => {
        this.selected_artikal = artikal;
      });
      this.$webpageEventBus.$on("wp_event_jm_updated", (resp) => {
        var artikal = this.mc.artikli.find((x) => x.id == resp.id);
        if (typeof artikal !== "undefined") {
          artikal.jm_id = resp.jm.id;
        }
      });
      this.$webpageEventBus.$on("close_email_dialog", () => {
        this.show_email = false;
      });
    },
    cleanup_event_listeners() {
      this.$webpageEventBus.$off("wp_client_changed");
      this.$webpageEventBus.$off("wp_worker_changed");
      this.$webpageEventBus.$off("wp_artikal_changed");
      this.$webpageEventBus.$off("wp_event_jm_updated");
      this.$webpageEventBus.$off("wp_department_changed");
      this.$webpageEventBus.$off("close_email_dialog");
    },
  },
  mounted() {
    this.visible = true;
    this.setup_event_listeners();
  },
  destroyed() {
    this.cleanup_event_listeners();
  },
};
</script>
<style scoped>
.height-90vh {
  height: calc(90vh - 200px);
  overflow-y: auto;
}

.v-tooltip__content {
  color: black;
  opacity: 1;
}
</style>
